import React from 'react';
import { usePanels } from './App';

const ProjectsPanel = () => {
  const { swapPanel } = usePanels();

  return (
    <div id="projectsPanel" className="Panel Panel-right" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <h1>Coming Soon...</h1>
      <p>We are working on it. Stay tuned!</p>
      <button 
        className="btn-back left-panel-btn" 
        onClick={() => swapPanel('menu', 'leftPanel')}
      >
        ⬅ Back
      </button>
    </div>
  );
};

export default ProjectsPanel;
